import React, { useEffect, useState } from "react";
import { FormKit } from "@/formkit";
import { RecordHubPageContainer } from "@/components/SmartRequest/RecordHubPageContainer";
import { UiKit } from "@datavant/uikit";
import { FORM_WIDTH } from "@/components/primitives/FormSizing";
import { FrequentlyAskedLoginQuestionSections } from "@/components/okta/FrequentlyAskedLoginQuestions";
const LoginQuestions = () => {
    const [form, setForm] = useState(undefined);
    // workaround to make the font larger/bolder and still use formkit
    // breadcrumbs only allows things of the type string so this is the only
    // way to get the desired styling
    useEffect(() => {
        const FrequentlyAskedQuestions = {
            nav: {
                title: "Frequently Asked Questions (FAQs)",
                showStatusIcons: true,
                getBreadcrumbs: (router) => [
                    {
                        label: "Back to login",
                        onClick: () => router.push("/login"),
                    },
                    {
                        label: "FAQs",
                    },
                ],
            },
            width: FORM_WIDTH,
            sections: FrequentlyAskedLoginQuestionSections,
            initialValue: () => {
                return {};
            },
        };
        setForm(FrequentlyAskedQuestions);
    }, []);
    return (<RecordHubPageContainer padding={"0px"} dontShowFooter={true}>
      {!form && <UiKit.SpinnerWithText text={"Loading..."} mt={"0px"}/>}
      {form && <FormKit.Form form={form}/>}
    </RecordHubPageContainer>);
};
export default LoginQuestions;
